import {useEventsPublisher} from "event-bus";
import {useBackendApi} from "./backendApi";
import {ValidationSchema} from "validation-schema";

export interface UpdatePasswordRequest {
  oldPassword: string,
  newPassword: string,
}

export interface SetPasswordRequest {
  password: string,
}

export const PASSWORD_UPDATED = 'PASSWORD_UPDATED';

export function usePasswordService() {
  const api = useBackendApi();

  const eventsPublisher = useEventsPublisher();

  const updatePassword = async (request: UpdatePasswordRequest) => {
    await api.put('/identity/password', request);

    eventsPublisher.publish(PASSWORD_UPDATED, {});
  };

  const setPassword = async (request: SetPasswordRequest) => {
    await api.put('/identity/password/set', request);

    eventsPublisher.publish(PASSWORD_UPDATED, {});
  }

  const getSetPasswordValidationSchema = () => {
    return {
      password: {
        type: 'string',
        constraints: {
          required: true,
          minLength: 8,
        },
      },
      password2: {
        type: 'string',
        constraints: {
          required: true,
          match: {
            value: 'password',
            message: 'The entered passwords don\'t match',
          },
        },
      },
    } as ValidationSchema;
  }

  const getUpdatePasswordValidationSchema = () => {
    return {
      oldPassword: {
        type: 'string',
        constraints: {
          required: true,
        },
      },
      newPassword: {
        type: 'string',
        constraints: {
          required: true,
          minLength: 8,
        },
      },
      newPassword2: {
        type: 'string',
        constraints: {
          required: true,
          match: {
            value: 'newPassword',
            message: 'The entered passwords don\'t match',
          },
        },
      },
    } as ValidationSchema;
  };


  return {
    updatePassword,
    setPassword,
    getUpdatePasswordValidationSchema,
    getSetPasswordValidationSchema,
  };
}
